class LocationDetailsModel {
    constructor({
                    id = null,
                    companyId = null,
                    companyName = null,
                    locationName = null,
                    locationAddress = null,
                    locationTypeCode = null,
                    locationType = null,
                    type = null,
                    countryId = null,
                    countryName = null,
                    cityId = null,
                    city = null,
                    postalId = null,
                    landmark = null,
                    postalArea = null,
                    latitude = null,
                    longitude = null,
                    phoneCode = null,
                    phoneNumber = null,
                    email = null,
                    pickupTime = null,
                    countryCode = null,
                    locationCode = null,
                    locationCc = null,
                    originHubName = null,
                    originHubId = null,
                    returnHubName = null,
                    returnHubId = null,
                    returnInfoName = null,
                    locationCountryCode = null,
                    nationalAddress = null,
                    vendorId = null,
                    vendorName = null,
                    exceptionHub = [],
                    numDeliverySlots = null,
                    facilitySlots = [],
                    storageShipmentCapacity = null,
                    storageWeightCapacity = null,
                    storageWeightUnit = null,
                    storageVolumetricCapacity = null,
                    storageVolumetricUnit = null,
                    processingShipmentCapacity = null,
                    processingWeightCapacity = null,
                    processingWeightUnit = null,
                    processingVolumetricCapacity = null,
                    processingVolumetricUnit = null,
                } = {}) {
        this.id = id;
        this.companyId = companyId;
        this.companyName = companyName;
        this.locationName = locationName;
        this.locationAddress = locationAddress;
        this.locationTypeCode = locationTypeCode;
        this.locationType = locationType;
        this.type = type;
        this.countryId = countryId;
        this.countryName = countryName;
        this.cityId = cityId;
        this.city = city;
        this.postalId = postalId;
        this.landmark = landmark;
        this.postalArea = postalArea;
        this.latitude = latitude;
        this.longitude = longitude;
        this.phoneCode = phoneCode;
        this.phoneNumber = phoneNumber;
        this.email = email;
        this.pickupTime = pickupTime;
        this.countryCode = countryCode;
        this.locationCode = locationCode;
        this.locationCc = locationCc;
        this.originHubName = originHubName;
        this.originHubId = originHubId;
        this.returnHubName = returnHubName;
        this.returnHubId = returnHubId;
        this.returnInfoName = returnInfoName;
        this.locationCountryCode = locationCountryCode;
        this.nationalAddress = nationalAddress;
        this.vendorId = vendorId;
        this.vendorName = vendorName;
        this.exceptionHub = exceptionHub.map(e => new ExceptionHub(e));
        this.numDeliverySlots = numDeliverySlots;
        this.facilitySlots = facilitySlots.map(f => new FacilitySlots(f));
        this.storageShipmentCapacity = storageShipmentCapacity;
        this.storageWeightCapacity = storageWeightCapacity;
        this.storageWeightUnit = storageWeightUnit;
        this.storageVolumetricCapacity = storageVolumetricCapacity;
        this.storageVolumetricUnit = storageVolumetricUnit;
        this.processingShipmentCapacity = processingShipmentCapacity;
        this.processingWeightCapacity = processingWeightCapacity;
        this.processingWeightUnit = processingWeightUnit;
        this.processingVolumetricCapacity = processingVolumetricCapacity;
        this.processingVolumetricUnit = processingVolumetricUnit;
    }

    static fromJson(json) {
        return new LocationDetailsModel({
            id: json.id ?? null,
            companyId: json.company_id ?? null,
            companyName: json.company_name ?? null,
            locationName: json.location_name ?? null,
            locationAddress: json.location_address ?? null,
            locationTypeCode: json.location_type_code ?? null,
            locationType: json.location_type ?? null,
            type: json.type ?? null,
            countryId: json.country_id ?? null,
            countryName: json.country_name ?? null,
            cityId: json.city_id ?? null,
            city: json.city ?? null,
            postalId: json.postal_id ?? null,
            landmark: json.landmark ?? null,
            postalArea: json.postal_area ?? null,
            latitude: json.latitude ?? null,
            longitude: json.longitude ?? null,
            phoneCode: json.phone_code ?? null,
            phoneNumber: json.phone_number ?? null,
            email: json.email ?? null,
            pickupTime: json.pickup_time ?? null,
            countryCode: json.country_code ?? null,
            locationCode: json.location_code ?? null,
            locationCc: json.location_cc ?? null,
            originHubName: json.origin_hub_name ?? null,
            originHubId: json.origin_hub_id ?? null,
            returnHubName: json.return_hub_name ?? null,
            returnHubId: json.return_hub_id ?? null,
            returnInfoName: json.return_info_name ?? null,
            locationCountryCode: json.location_country_code ?? null,
            nationalAddress: json.national_address ?? null,
            vendorId: json.vendor_id ?? null,
            vendorName: json.vendor_name ?? null,
            exceptionHub: json.exception_hub
                ? json.exception_hub.map(e => ExceptionHub.fromJson(e))
                : [],
            numDeliverySlots: json.num_delivery_slots ?? null,
            facilitySlots: json.facility_slots
                ? json.facility_slots.map(f => FacilitySlots.fromJson(f))
                : [],
            storageShipmentCapacity: json.storage_shipment_capacity ?? null,
            storageWeightCapacity: json.storage_weight_capacity ?? null,
            storageWeightUnit: json.storage_weight_unit ?? null,
            storageVolumetricCapacity: json.storage_volumetric_capacity ?? null,
            storageVolumetricUnit: json.storage_volumetric_unit ?? null,
            processingShipmentCapacity: json.processing_shipment_capacity ?? null,
            processingWeightCapacity: json.processing_weight_capacity ?? null,
            processingWeightUnit: json.processing_weight_unit ?? null,
            processingVolumetricCapacity: json.processing_volumetric_capacity ?? null,
            processingVolumetricUnit: json.processing_volumetric_unit ?? null,
        });
    }

    toJson() {
        return {
            id: this.id,
            company_id: this.companyId,
            company_name: this.companyName,
            location_name: this.locationName,
            location_address: this.locationAddress,
            location_type_code: this.locationTypeCode,
            location_type: this.locationType,
            type: this.type,
            country_id: this.countryId,
            city_id: this.cityId,
            country_name: this.countryName,
            city: this.city,
            postal_id: this.postalId,
            landmark: this.landmark,
            postal_area: this.postalArea,
            latitude: this.latitude,
            longitude: this.longitude,
            phone_code: this.phoneCode,
            phone_number: this.phoneNumber,
            email: this.email,
            pickup_time: this.pickupTime,
            country_code: this.countryCode,
            location_code: this.locationCode,
            location_cc: this.locationCc,
            origin_hub_name: this.originHubName,
            origin_hub_id: this.originHubId,
            return_hub_name: this.returnHubName,
            return_hub_id: this.returnHubId,
            return_info_name: this.returnInfoName,
            location_country_code: this.locationCountryCode,
            national_address: this.nationalAddress,
            vendor_id: this.vendorId,
            vendor_name: this.vendorName,
            exception_hub: this.exceptionHub.map(e => e.toJson()),
            num_delivery_slots: this.numDeliverySlots,
            facility_slots: this.facilitySlots.map(f => f.toJson()),
            storage_shipment_capacity: this.storageShipmentCapacity,
            storage_weight_capacity: this.storageWeightCapacity,
            storage_weight_unit: this.storageWeightUnit,
            storage_volumetric_capacity: this.storageVolumetricCapacity,
            storage_volumetric_unit: this.storageVolumetricUnit,
            processing_shipment_capacity: this.processingShipmentCapacity,
            processing_weight_capacity: this.processingWeightCapacity,
            processing_weight_unit: this.processingWeightUnit,
            processing_volumetric_capacity: this.processingVolumetricCapacity,
            processing_volumetric_unit: this.processingVolumetricUnit,
        };
    }
}

class ExceptionHub {
    constructor(data = {}) {
        // Add ExceptionHub fields and constructor logic
    }

    static fromJson(json) {
        // Add parsing logic
        return new ExceptionHub(json);
    }

    toJson() {
        // Add serialization logic
    }
}

class FacilitySlots {
    constructor(data = {}) {
        // Add FacilitySlots fields and constructor logic
    }

    static fromJson(json) {
        // Add parsing logic
        return new FacilitySlots(json);
    }

    toJson() {
        // Add serialization logic
    }
}

export {LocationDetailsModel, ExceptionHub, FacilitySlots};
